import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import HouseService from '../../services/HouseService';
import CallButton from '../Common/CallButton/CallButton';
import { UserType } from '../../enums/common';

interface InputProps {
    houseId: number;
}

const houseService = new HouseService();

const HousesCustomersTab = ({ houseId }: InputProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        houseService
            .getAllCustomerForHouse(houseId)
            .then((res) => {
                setData(res?.data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    const columns: CommonListColumn[] = [
        { label: 'Id', field: 'id' },
        { label: 'First Name', field: 'fname' },
        { label: 'Last Name', field: 'lname' },
        { label: 'Email', field: 'email' },
        { label: 'Address', field: 'address' },
        {
            label: 'Mobile',
            stopRowClick: true,
            render: (row) => row?.mobile ? (
                <CallButton
                    toPhoneNumber={row?.mobile}
                    userType={UserType.CUSTOMER}
                    referenceId={row?.id}
                    referenceModelName="CUSTOMER_MODEL"
                />
            ) : '-',
        },
        { label: 'Account Status', field: 'accountStatus', type: 'status' },
        { label: 'House', field: 'houseId' },
        { label: 'Contact', field: 'contactId' },
        { label: 'Account', field: 'accountId' },
        {
            label: 'Actions',
            stopRowClick: true,
            render: (row) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Link href={`/#/Customers/${row.id}/show`}>
                        <Button variant="contained" color="primary" size="small">Show</Button>
                    </Link>
                    <Link href={`/#/Customers/${row.id}/edit`}>
                        <Button variant="contained" color="secondary" size="small">Edit</Button>
                    </Link>
                </div>
            ),
        },
    ];

    return (
        <CommonListTable
            columns={columns}
            data={data}
            loading={loading}
            emptyText="No Customer Found"
        />
    );
};

export default HousesCustomersTab;
